import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import { i18n } from '@fs/zion-locale'

export default function useIndustryLinks({ nonReligiousMode, isNonEnCoreLanguage, isCoreLanguage }) {
  const { t } = useTranslation()
  const helpLocationsPath = useFeatureFlag('help_locations_path').isOn
  let affiliatesUrl = `https://www.familysearch.org/${i18n.language}/affiliates/about` /* Prod link since this is not on beta */
  if (helpLocationsPath) {
    affiliatesUrl = `/${i18n.language}/locations/affiliates/about`
  }

  return {
    id: 'industry',
    title: t('nav.industry', 'Industry'),
    hidden: isNonEnCoreLanguage || !isCoreLanguage,
    subNav: [
      {
        id: 'affilLib',
        text: t('nav.links.industry.affilLib', 'Affiliate Libraries'),
        url: affiliatesUrl,
        linkName: 'ff_industry_affilLib',
        dataTestId: 'ff_affiliate_libraries',
        isNew: false,
        hidden: nonReligiousMode,
      },
      {
        id: 'archives',
        text: t('nav.links.industry.archives', 'Archives'),
        url: `/${i18n.language}/info/archive`,
        linkName: 'ff_industry_archives',
        dataTestId: 'ff_archives',
        isNew: false,
      },
      {
        id: 'devCenter',
        text: t('nav.links.industry.devCenter', 'Developer Center'),
        url: '/developers/',
        linkName: 'ff_industry_devCenter',
        dataTestId: 'ff_dev_center',
        isNew: false,
      },
      {
        id: 'solutionsGal',
        text: t('nav.solutions-gallery', 'Solutions Gallery'),
        url: `https://www.familysearch.org/${i18n.language}/innovate/solutions-gallery`,
        linkName: 'ff_industry_solutionsGal',
        dataTestId: 'ff_solutions_gallery',
        isNew: false,
        hidden: nonReligiousMode,
      },
    ],
  }
}
